import { createContext, useContext, ReactNode } from 'react';
import { useAdminActionFeed } from '../hooks/useAdminActionFeed';

type Ctx = ReturnType<typeof useAdminActionFeed>;

const AdminActionFeedContext = createContext<Ctx | null>(null);

export function AdminActionFeedProvider({
  token,
  children,
}: {
  token: string | null;
  children: ReactNode;
}) {
  const feed = useAdminActionFeed(token);
  return <AdminActionFeedContext.Provider value={feed}>{children}</AdminActionFeedContext.Provider>;
}

export function useAdminActionFeedContext() {
  const ctx = useContext(AdminActionFeedContext);
  if (!ctx) {
    // Provider not mounted — return a safe no-op shape.
    return {
      unreadCount: 0,
      capped: false,
      unreadOfferingIds: new Set<string>(),
      pollUnread: async () => undefined,
      clearLocal: () => undefined,
      clearOffering: () => undefined,
    } as Ctx;
  }
  return ctx;
}
